<template>
  <div id="popup">
    <div id="popup-overlay">
     <div id="popup-content"></div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Popup"
    }
</script>

<style scoped>
  #popup-overlay {
    position: fixed;
    left: 0;
    top:0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.2);
  }
  #popup-content {
    width: 50vw;
    height: auto;
    margin: 10vw auto;
    background: white;
    box-shadow: 0 4px 10px rgba(0,0,0,.3);
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Blocks/Popup.vue